import { useRouter } from 'next/router';

import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';

import { getMarkdownPath } from 'components/doc/doc-actions-drop-utils';
import { useToast } from 'contexts';
import { useAction } from 'hooks';

const DocActionsDrop = () => {
	const router = useRouter();
	const toast = useToast();
	const markdownPath = getMarkdownPath(router);
	const [onCopy, copyTask] = useAction(async () => {
		const response = await window.fetch(markdownPath);
		if (!response.ok) throw new Error(`Unable to fetch markdown: ${response.status}`);
		await window.navigator.clipboard.writeText(await response.text());
		toast.showSuccess(200, 'Copied markdown!');
	});

	return (
		<div className='flex-start flex-wrap gap-2'>
			<Button variant='ghost' size='xs' isLoading={copyTask.running} onClick={onCopy}>
				<Icon data-icon='inline-start' type='far' icon='copy' aria-hidden />
				Copy
			</Button>
			<Link variant='outline' size='xs' href={markdownPath} target='_blank'>
				<Icon data-icon='inline-start' type='fab' icon='markdown' aria-hidden />
				Markdown
			</Link>
		</div>
	);
};

export { DocActionsDrop };
